import { User } from '../models/user';
// import { SysProductYvNameEnum } from '../models/enums/sysProductEnums';

export const getPermission = (currentUser: User | undefined, permission: string) => {
  // Då alla menyval inte har en permission hårdkodat i sideMenu.tsx än skickas tom sträng in på dom = visa för användare
  let hasPermission = true;
  if (permission !== '' && currentUser?.sysProducts) {
    const sysProductsPermissions = currentUser?.sysProducts.flatMap((x) => x.permissions);
    if (sysProductsPermissions !== undefined) {
      hasPermission = sysProductsPermissions.some((p) => p === permission);
    } else {
      hasPermission = false;
    }
  }
  return hasPermission;
};
